import React from 'react';
import { Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTabs = styled(Tabs)(({ theme }) => ({
  root: {
    borderBottom: '1px solid #E0E0E0',
  },
  '& .MuiTabs-indicator': {
    color: 'red',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > span': {
      width: '100%',
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

const TabsComponent = (props) => {
  return <StyledTabs {...props} TabIndicatorProps={{ children: <span /> }} />;
};

export default TabsComponent;
